<template>
  <div class="scrollbar-inner d-flex bg-secondary overflow-x" >
      <div class="w-100 h-100">
      <div class="border-0 mb-0 shadow-none h-100 position-center pr bg-white overflow-scroll">
        <button class="btn chat-close btn-close visible-xs" @click="$emit('overlayClicked')"><i class="fa fa-times"></i></button>
        <slot />
        
      </div>
    </div>
    <div class="sidebar-overlay" @click="$emit('overlayClicked')">
    </div>
  </div>
</template>
<script>
export default {
  name: "SidebarRight",
  data() {
    return {
      show: false
    };
  },
  methods: {
    outside() {
      this.show = false;
      this.$emit("change", this.show);
      console.log("clicked outside!");
    }
  }
};
</script>
<style lang="scss" scoped>
.scrollbar-inner .overflow-scroll{
  overflow: hidden;
 overflow-y: scroll;
}
</style>